import { BaseDataElement } from './base-data-element.model';

export class IntegerDataElement extends BaseDataElement {

  minimum: Number;
  maximum: Number;
  minimumOverrider: Number;
  maximumOverrider: Number;
}
